export const section_titles = [
    { title: 'О нас', content_id: '#about_content' },
    { title: 'Почему мы?', content_id: '#benefits_content' },
    { title: 'Сотрудники', content_id: '#employeers_content' },
    { title: 'Запись', content_id: '#courses_content' },
]